export type JoinModeT = 'join' | 'invite';
export type AuthStateT = 'login' | 'signup';

export enum PlansName {
  registered = 'Free',
  basic = 'Basic',
  pro = 'Pro',
  enterprise = 'Enterprise',
  enterprise_trial = 'Enterprise',
}
